import React from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown, Space } from "antd";
import useAuth from "../../hooks/useAuth";
import { ChevronDown } from "lucide-react";

const SelectProfile = () => {
  const navigate = useNavigate();
  const { auth, setAuth } = useAuth();
  const logout = () => {
    // Clear all localStorage except rehema_device_id
    const deviceId = localStorage.getItem("rehema_device_id");
    Object.keys(localStorage)?.forEach((key) => {
      if (key !== "rehema_device_id") {
        localStorage?.removeItem(key);
      }
    });

    // restore deviceId just in case
    if (deviceId) {
      localStorage?.setItem("rehema_device_id", deviceId);
    }

    setAuth({});
    navigate("/");
  };

  const items = [
    {
      label: "User Profile",
      key: "0",
    },
    {
      label: "Account Settings",
      key: "1",
    },
    {
      label: "Support",
      key: "3",
    },
    {
      label: "Logout",
      key: "4",
      onClick: logout,
    },
  ];
  return (
    <Dropdown
      menu={{ items }}
      trigger={["click"]}
      placement="topRight"
      className="cursor-pointer"
    >
      <Space
        style={{
          cursor: "pointer",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: 150,
        }}
      >
        {`${auth?.user?.firstname} ${auth?.user?.lastname}`}
        <ChevronDown />
      </Space>
    </Dropdown>
  );
};

export default SelectProfile;
